import { render, staticRenderFns } from "./OpticalPath.vue?vue&type=template&id=65ad3b13&scoped=true"
import script from "./OpticalPath.vue?vue&type=script&lang=js"
export * from "./OpticalPath.vue?vue&type=script&lang=js"
import style0 from "./OpticalPath.vue?vue&type=style&index=0&id=65ad3b13&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ad3b13",
  null
  
)

export default component.exports